import React from 'react';
import moment from 'moment';
import { connect } from 'dva';
import { routerRedux } from 'dva/router';
import { Icon } from 'antd';

import { getNotifications, hasUnreadNotification } from 'selectors';
import classnames from 'classnames';

import UserDisplay from '../User/Display';
import DateDisplay from '../Common/DateDisplay';


import styles from './NotificationList.less';


class NotificationList extends React.Component {
  handleClickNotification = (notification) => {
    const [category, action] = notification.category.split('.');
    const { dispatch } = this.props;
    let route;
    if (category === 'comment') {
      route = {
        pathname: '/comment',
        query: { type: action },
      };
      if (action === 'create') {
        route.query = {};
      } else if (action === 'resolved') {
        route.query = { created: 1, state: 2 };
      } else if (action === 'reopened') {
        route.query = { subscribed: 1, state: 3 };
      } else if (action === 'unresolved') {
        route.query = { subscribed: 1, state: 4, notme: 1 };
      }
      const refs = notification.data && notification.data.refs;
      if (refs && refs.length > 0) {
        route.query = { ...route.query, ...refs[refs.length - 1] };
      }
    } else if (category === 'file') {
      route = {
        pathname: '/file',
        query: { action: 'latest', from: moment(notification.notifiedAt).utc().format('YYYY-MM-DD') },
      };
    } else if (category === 'payment') {
      route = {
        pathname: '/payment',
      };
    } else {
      route = {
        pathname: '/activity',
        query: { category, action, notme: 1 },
      };
    }

    dispatch(routerRedux.push(route));

    if (notification.status !== 1) {
      dispatch({
        type: 'notification/updateNotification',
        payload: {
          id: notification.id,
          status: 1, // READ
        },
      });
    }
  }

  markAllAsRead = () => {
    this.props.dispatch({
      type: 'notification/markAllAsRead',
    });
  }

  renderNotification = (notification) => {
    let content = notification.content;
    const { counter, issuers } = notification.data || {};
    let firstUserId = null;
    let userCount = 0;
    if (issuers && issuers.length > 0) {
      userCount = issuers.length - 1;
      firstUserId = issuers[0];
    }
    if (!content) {
      if (notification.category === 'file.upload') {
        content = (
          <span>
            <Icon type="file" /> <strong>{counter}</strong> file mới được upload
            {firstUserId && <span> bởi <UserDisplay userId={firstUserId} className={styles.username} /> </span>}
            {userCount > 0 && <span> và {} người khác</span>}
          </span>);
      }
      if (notification.category === 'comment.create') {
        content = (
          <span>
            <Icon type="message" /> <strong>{counter}</strong> bình luận mới
            {firstUserId && <span> của <UserDisplay userId={firstUserId} className={styles.username} /> </span>}
            {userCount > 0 && <span> và {} người khác</span>}
          </span>);
      }
      if (notification.category === 'comment.resolved') {
        content = (
          <span>
            <Icon type="message" />
            {firstUserId && <span> <UserDisplay userId={firstUserId} className={styles.username} /> </span>}
            {userCount > 0 && <span> và {} người khác</span>}
            <span> đã xử lý xong công việc theo bình luận của bạn </span>
          </span>);
      }
      if (notification.category === 'comment.reopened') {
        content = (
          <span>
            <Icon type="message" />
            {firstUserId && <span> <UserDisplay userId={firstUserId} className={styles.username} /> </span>}
            {userCount > 0 && <span> và {} người khác</span>}
            <span> đã bỏ tác vụ xử lý của bạn</span>
          </span>);
      }
      if (notification.category === 'comment.unresolved') {
        content = (
          <span>
            <Icon type="hourglass" />
            <span> Có bình luận liên quan đến bạn vẫn chưa được xử lý</span>
          </span>);
      }
      if (notification.category === 'payment.cost_calc' || notification.category === 'payment.cost_recalc' || notification.category === 'payment.other') {
        content = (
          <span>
            <Icon type="wallet" />
            <span> Thông báo thu phí dịch vụ kế toán</span>
          </span>);
      }
    }

    return (
      <div
        key={notification.id}
        onClick={() => this.handleClickNotification(notification)}
        className={classnames(styles.item, { [styles.unread]: !notification.status })}
      >
        {content}
        <div className={styles.date}><DateDisplay value={notification.notifiedAt} format="datetime" /></div>
      </div>
    );
  }

  render() {
    const { notifications, hasUnread } = this.props;

    return (
      <div className={styles.list}>
        {notifications && notifications.length === 0 &&
          <div className={styles.empty}>Bạn không có thông báo mới</div>
        }
        <div className={styles.listContent}>
          {notifications && notifications.map(item => this.renderNotification(item))}
        </div>
        <div className={styles.viewall}>
          {/* <Link to="/activity"> Hoạt động</Link> |
          <Link to="/comment"> Bình luận</Link> */}
          <a onClick={this.markAllAsRead} disabled={!hasUnread}>Đánh dấu tất cả đã đọc</a>
        </div>
      </div>
    );
  }
}


export default connect(state => ({
  notifications: getNotifications(state),
  hasUnread: hasUnreadNotification(state),
}))(NotificationList);



// WEBPACK FOOTER //
// ./src/components/Notification/NotificationList.js